import { render } from "./ControleSmtpView.vue?vue&type=template&id=51ee0ff2"
import script from "./ControleSmtpView.vue?vue&type=script&lang=js"
export * from "./ControleSmtpView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\SGCAD25\\Garantidoras\\FrontBack\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__